import CreateInvestmentError from './CreateInvestmentError';
class BrickNumberExceedsAvailableBricks extends CreateInvestmentError {
    constructor(options) {
        super('The number of bricks is bigger than available bricks', options);
    }
}
export default BrickNumberExceedsAvailableBricks;
